import React from 'react'
import { FormTinsion } from './FormTinsion';
import { Dialog } from 'primereact/dialog';
import { Button } from 'reactstrap';


export const ModalTinsion = (props) => {

    const {
        modal, tittle, closeDialog, method,
        name,
        handleInputChange, loading,
        saveCreate, saveUpdateBacterium,
    } = props;

    return (
        <Dialog
            visible={modal}
            onHide={closeDialog}
            closable={false}
            modal
            maskClassName="custom-total-mask"
            header={
                <div className="Global-dialog-header">
                    <div className="Global-dialog-header__content">
                        <div className="Global-dialog-icon">
                            <i className="icofont icofont-drug f-20"></i>
                        </div>

                        <div>
                            <div className="Global-dialog-title">
                                {tittle}
                            </div>
                        </div>
                    </div>
                </div>
            }
            draggable={false}
            className={`Global-dialog Global-dialog Global-blue Global-small-v3`}
            footer={
                <>
                    {
                        method === "create" && <Button
                            color="secondary"
                            size="sm"
                            className={loading ? "disabled progress-bar-animated progress-bar-striped" : ""}
                            onClick={saveCreate}
                        >
                            {
                                loading ? "Creando...." : "Crear"
                            }
                        </Button>
                    }
                    {
                        method === "update" && <Button
                            color="secondary"
                            size="sm"
                            className={loading ? "disabled progress-bar-animated progress-bar-striped" : ""}
                            onClick={saveUpdateBacterium}
                        >
                            {
                                loading ? "Actualizando...." : "Actualizar"
                            }
                        </Button>
                    }
                    <Button
                        size="sm"
                        color='danger'
                        type="button"
                        onClick={closeDialog}>
                        Cancelar
                    </Button>
                </>
            }

        >
            {
                method === "create"
                    ? <FormTinsion
                        button={"Crear"}
                        {...{ closeDialog, loading, name, handleInputChange, methodAction: saveCreate }}
                    />
                    : (method === "update")
                        ?
                        <FormTinsion
                            button={"Actualizar"}
                            {...{ closeDialog, loading, name, handleInputChange, methodAction: saveUpdateBacterium }} />
                        :
                        null
            }
        </Dialog>
    )
}
